import { render } from "./textbook-list.vue?vue&type=template&id=45fe2c0b&scoped=true"
import script from "./textbook-list.vue?vue&type=script&lang=js"
export * from "./textbook-list.vue?vue&type=script&lang=js"

import "./textbook-list.vue?vue&type=style&index=0&id=45fe2c0b&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fe2c0b"]])

export default __exports__